import qs from "qs";
import request from "@/utils/request";

export function getAuditHistory(params) {
  return request({
    url: `/api/admin/users/audit/`,
    method: `get`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
}
